import React, { useEffect, useState, useCallback } from 'react'
import { requestProductStockLogs } from 'requests/products'
import { useParams, useHistory } from 'react-router-dom'
import { productInfo } from 'config/submenus/product'
import { InfoPage } from 'templates/InfoPage'
import { SideMenu } from 'components/SideMenu'
import { CardList } from 'ui-components/CardList'
import { Pagination } from 'ui-components/Pagination'
import { ProgressBar } from 'ui-components/ProgressBar'
import { StockTracking } from './components/StockTracking'
import { PaginationContainer } from './styles'

export default function ProductStockTracking() {
  const [logs, setLogs] = useState([])
  const [loading, setLoading] = useState(false)
  const [responseError, setResponseError] = useState({})
  const [pagination, setPagination] = useState({})

  const { id } = useParams()
  const history = useHistory()

  const getProductStockLogs = useCallback(async (page = 1) => {
    setLoading(true)
    const response = await requestProductStockLogs({ id, page })

    setLoading(false)
    if (response.error) {
      return setResponseError(response)
    }

    setPagination(response.meta.pagination)
    return setLogs(response.data)
  }, [id])

  useEffect(() => {
    const query = new URLSearchParams(window.location.search)
    const page = query.get('page')

    getProductStockLogs(page)
  }, [getProductStockLogs])

  // TODO: criar custom hook para pagination actions
  const onPaginationClick = (page) => {
    const params = new URLSearchParams()
    params.append('page', page)
    history.push({ search: params.toString() })
    getProductStockLogs(page)
  }

  const renderErrorMessage = () => (
    <div>
      {responseError.message}
    </div>
  )

  const renderLog = (log) => (
    <StockTracking
      key={log.id}
      stockTracking={log}
    />
  )

  const renderMenu = () => (
    <SideMenu submenu={productInfo(id)} />
  )

  const renderList = () => (
    <CardList>
      { logs.map(renderLog) }

      <PaginationContainer>
        <Pagination
          showInfo
          onClick={onPaginationClick}
          pagination={pagination}
          loading={loading}
        />
      </PaginationContainer>
    </CardList>
  )

  // TODO: passar nome do produto via context
  return logs.length ? (
    <InfoPage
      renderMenu={renderMenu}
      title={logs[0]?.attributes?.product?.name}
      subtitle="Informações do produto"
    >
      { renderList() }
      { responseError.error ? renderErrorMessage() : null }
    </InfoPage>
  ) : <ProgressBar start={loading} />
}
